import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    reportPage_title: 'Отчет',
    reportPage_errorLoadTable: 'Не удалось загрузить отчет',
    reportPage_staffId: 'ID сотрудика',
    reportPage_iin: 'ИИН сотрудника',
    reportPage_FIO: 'ФИО сотрудника',
    reportPage_logDate: 'Дата',
    reportPage_visitingTime: 'Время',
    reportPage_serviceProviderId: 'ID организации',
    reportPage_serviceProviderName: 'Наименование ораганизации',
    reportPage_deviceUid: 'ID устроиство',
    reportPage_deviceInfo: 'Устроиство',
    reportPage_fromDate: 'дата с',
    reportPage_toDate: 'дата по',
    reportPage_isShowDataTable: 'Для отображения данных необходимо заполнить населенный пункт',
  },
  kk: {
    reportPage_title: 'Есеп',
    reportPage_errorLoadTable: 'Есепті жүктеу мүмкін болмады',
    reportPage_staffId: 'Қызметкердің ID',
    reportPage_iin: 'Қызметкердің ЖСН',
    reportPage_FIO: 'Қызметкердің аты-жөні',
    reportPage_logDate: 'Күні',
    reportPage_visitingTime: 'Уақыт',
    reportPage_serviceProviderId: 'ID ұйым',
    reportPage_serviceProviderName: 'Ұйымның атауы',
    reportPage_deviceUid: 'ID құрылғысы',
    reportPage_deviceInfo: 'Құрылғы',
    reportPage_fromDate: 'күні,бастап',
    reportPage_toDate: 'күні,дейін',
    reportPage_isShowDataTable: 'Деректерді көрсету үшін елді мекенді таңдау керек',
  }
});
